// extracted by mini-css-extract-plugin
export default {"container":"MenuItem_container__Gyq53","disabled":"MenuItem_disabled__1E-YG","focused":"MenuItem_focused__daRkx"};